export interface ChangedRange {
  start: number;
  previousEnd: number;
  nextEnd: number;
}

export function findChangedRange(previous: string, nextValue: string): ChangedRange | null {
  if (previous === nextValue) return null;

  let start = 0;
  while (
    start < previous.length &&
    start < nextValue.length &&
    previous[start] === nextValue[start]
  ) {
    start++;
  }

  let previousEnd = previous.length;
  let nextEnd = nextValue.length;
  while (
    previousEnd > start &&
    nextEnd > start &&
    previous[previousEnd - 1] === nextValue[nextEnd - 1]
  ) {
    previousEnd--;
    nextEnd--;
  }

  return { start, previousEnd, nextEnd };
}
